import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
    Box,
    Button,
} from '@chakra-ui/react'
import { InputText, Form } from '../../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../../helpers';

function CurrencyCreate({ meCloseEdit, loadList, data, edit }) {



    const [formData, setFormData] = useState({
        name: '',
        conversion_rate: 0,
        code:''
    });


    useEffect(() => {
        if (edit) {

            setFormData({ name: data.name, conversion_rate: data.conversion_rate,code:data.code })
        }
    }, [data, edit])

  

    const FormSchema = Yup.object().shape({
        name: Yup.string()
            .required('Currency name is required')
            .min(2, 'Name must be at least 2 characters')
            .max(100, 'Name must be less than 100 characters'),
        conversion_rate: Yup.number()
            .required('Currency name is required'),
        code: Yup.string()
            .required('Currency code is required')



    });




    const onSubmit = async (values, { setSubmitting }) => {
        try {
            const url = edit
                ? `${process.env.REACT_APP_API_URL}/currency/update`
                : `${process.env.REACT_APP_API_URL}/currency/create`;

            const payload=edit?{...values,id:data.id}:values
            await fetchWrapper.post(url, payload);
            loadList();
            meCloseEdit();

            toast(`Currency has been ${edit ? 'updated' : 'created'} successfully`, {
                type: "success"
            });

        } finally {
            setSubmitting(false);
        }
    };

    return (

        <Form
            enableReinitialize
            validationSchema={FormSchema}
            initialValues={formData}
            onSubmit={onSubmit}
        >


            <Box mb="0px">
                <InputText name="name" title="Name" inputProps={{ isRequired: true }} placeholder="Please Enter Currency Name" />
            </Box>
            <Box mb="0px">
                <InputText name="conversion_rate" title="Conversion rate" inputProps={{ isRequired: true }} placeholder="Please Enter Conversion Rate" />
            </Box>

            <Box mb="0px">
                <InputText name="code" title="Code" inputProps={{ isRequired: true }} placeholder="Please Enter code" />
            </Box>


            <Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
                mb={4}

                type='submit'
            >
                {edit ? 'Update Currency' : 'Add New Currency'}
            </Button>
        </Form>


    )
}

export default CurrencyCreate;